export default __webpack_public_path__ + "static/covid-cover-alt-665fd64e5aa2e55c29a21e06bc4a9ae7.jpg";